// global
import _ from 'lodash';
// local
import { sortString, sortNumber, toSearchableString } from 'app/lib/helper';

const TEMPLATE_NAME = 'ACCOUNT_LIST';

const sort = function(a, b) {
    const aName = _.get(a, 'client.name', null);
    const bName = _.get(b, 'client.name', null);
    let result = sortString(aName, bName);
    if (result !== 0) {
        return result;
    }
    result = sortNumber(b.profile, a.profile);
    if (result !== 0) {
        return result;
    }
    return sortString(a.name, b.name);
};

const initialState = () => ({
    loading: false,
    data: [],
    filter: {
        term: '',
        data: [],
    },
});

const filterByTerm = (item, term) => toSearchableString(item.name).includes(toSearchableString(term));

const filterData = (data, term) => {
    const result = data.filter(item => filterByTerm(item, term));
    if (sort) {
        result.sort(sort);
    }
    return result;
};

const reducer = (state = initialState(), action) => {
    switch (action.type) {
        case `${TEMPLATE_NAME}_PENDING`: {
            return {
                ...state,
                loading: true,
            };
        }
        case `${TEMPLATE_NAME}_REJECTED`: {
            return {
                ...state,
                loading: false,
            };
        }
        case `${TEMPLATE_NAME}_FULFILLED`: {
            const data = action.payload;
            return {
                ...state,
                loading: false,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term),
                },
            };
        }
        case `${TEMPLATE_NAME}_CREATE`: {
            const newRow = action.payload;
            // add the new item to the array
            const data = [...state.data, newRow];
            return {
                ...state,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term),
                },
            };
        }
        case `${TEMPLATE_NAME}_UPDATE`: {
            const updatedRow = action.payload;
            // update the row with the same ID with new data
            const data = state.data.map(row => (row.id === updatedRow.id ? updatedRow : row));
            return {
                ...state,
                data,
                filter: {
                    ...state.filter,
                    data: filterData(data, state.filter.term),
                },
            };
        }
        case `${TEMPLATE_NAME}_SEARCH`: {
            const term = action.payload;
            const data = filterData(state.data, term);
            return {
                ...state,
                filter: {
                    ...state.filter,
                    term,
                    data,
                },
            };
        }
        case `${TEMPLATE_NAME}_RESET`: {
            return initialState();
        }
        default:
            return state;
    }
};
export default reducer;
